export namespace IGetRetailerIdvStatusResponse {
  export enum IdvStatus {
    /**
     * Unknown status.
     */
    IDV_STATUS_UNKNOWN = 'IDV_STATUS_UNKNOWN',
    /**
     * The retailer has never received any IDV request.
     */
    NEVER_RECEIVED_IDV = 'NEVER_RECEIVED_IDV',
    /**
     * There is an pending IDV request waiting for the retailer's response.
     */
    HAS_PENDING_IDV_REQUEST = 'HAS_PENDING_IDV_REQUEST',
    /**
     * The retailer has responded all IDV requests.
     */
    IDV_REQUEST_RESPONDED = 'IDV_REQUEST_RESPONDED',
  }

  export enum VerificationAction {
    VERIFICATION_ACTION_UNKNOWN = 'VERIFICATION_ACTION_UNKNOWN',
    PLACE_AN_ORDER = 'PLACE_AN_ORDER',
    ORDER_JUST_PLACED = 'ORDER_JUST_PLACED',
    WAITING_ON_REVIEW = 'WAITING_ON_REVIEW',
    ESCALATE_TO_AN_AGENT = 'ESCALATE_TO_AN_AGENT',
  }

  /**
   * Return an instance of IGetRetailerIdvStatusResponse with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IGetRetailerIdvStatusResponse>
  ): IGetRetailerIdvStatusResponse =>
    ({
      ...(partial ?? {}),
    }) as IGetRetailerIdvStatusResponse;
}

export interface IGetRetailerIdvStatusResponse {
  idv_status: keyof typeof IGetRetailerIdvStatusResponse.IdvStatus | undefined;
  /**
   * clients should prefer to use idvStatus above, which has more
   * data. But we leave this in to support old clients that are used to
   * the boolean value
   * @deprecated
   */
  has_pending_idv: boolean | undefined;
  is_pending_risk_analysis: boolean | undefined;
  has_brand_order_waiting_on_review: boolean | undefined;
  action_required_if_not_confirmed:
    | keyof typeof IGetRetailerIdvStatusResponse.VerificationAction
    | undefined;
}
